import { render } from "./AddAuthTokenForm.vue?vue&type=template&id=5f63ee47"
import script from "./AddAuthTokenForm.vue?vue&type=script&lang=js"
export * from "./AddAuthTokenForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__